<template>
    <div>
        <!-- note: ok-only hack is just simpler than defining a "cancel only" footer slot -->
        <b-modal
            id="personaPicker"
            v-model="modalShow"
            scrollable
            ok-only
            ok-title="Cancel"
            size="lg"
            centered
            lazy
            :title="modalTitle"
        >
            <b-container fluid>
                <b-form-row align-v="center">
                    <b-col cols="10">
                        <b-list-group>
                            <b-list-group-item
                                v-for="(role, idx) in roleOptions"
                                :key="idx"
                                button
                                variant="light"
                                @click.prevent="selectPersona(role.value)"
                            >
                                {{ role.text }}
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                    <b-col />
                </b-form-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'PersonaPickerModal',

    props: {
        realmName: { type: String, default: 'undefined system name' },
        availablePersonae: {
            type: Array,
            default() { return []; },
        },
    },

    data() {
        return {
            modalShow: false,
            selectedPersona: null,
        };
    },

    computed: {
        modalTitle() {
            return 'Please select one of your roles for the ' + this.realmName + 'system';
        },

        roleOptions() {
            let options = [];
            if (this.availablePersonae) {
                this.availablePersonae.forEach((persona) => {
                    let row = {};
                    row.text = persona.title;
                    row.value = persona.persona_id;
                    options.push(row);
                });
            }
            return options;
        },
    },

    methods: {
        selectPersona(personaId) {
            this.selectedPersona = personaId;
            this.$emit('personaPicker:personaSelected', this.selectedPersona);
            this.hide();
        },

        show() {
            this.modalShow = true;
        },

        hide() {
            this.modalShow = false;
        },
    },
};
</script>
